const dbRequest    = require('../../../../../js-network/db-request')
const multitable   = require('../../../../../components/multitable/multitable')
const fullcontForm = require('../../../../../components/fullcont/fullcont-form')
const timeDate     = require('../../../../../js-handler/time-date')
const dialog       = require('./accountreconciliation-dialog')

export function cancelLoad(htmlFc) {
  htmlFc.pendingRequest = (htmlFc.pendingRequest || 0) + 1
  htmlFc.loadingTransactions = false
  setSelectionLoading(htmlFc, false)
}

function setSelectionLoading(htmlFc, loading) {
  const container = htmlFc.fullcontHTML.querySelector('#accountreconciliation_form_transactions')
  container.inert = loading
  container.setAttribute('aria-busy', String(loading))
}

// Usa el mismo orden y tipos de campos que getValues para no detectar cambios al abrir.
export function rememberSelection(htmlFc) {
  multitable.start({ act: 'getValues', entityMT: htmlFc.entityMT })
  htmlFc.entityMT.forEach((table) => { table.dataCopy = JSON.parse(JSON.stringify(table.data)) })
}

export function setDefaultValue(htmlFc) {
  cancelLoad(htmlFc)
  const field = htmlFc.form.find((element) => element.name === 'date')
  field.value = timeDate.convertDateToInput()
  field.html.querySelector('input').value = field.value
  htmlFc.formCopy.find((element) => element.name === 'date').value = field.value
}

// otherField del autocomplete carga pendientes; las respuestas viejas no reemplazan otra cuenta.
export async function getTransactions(detail, htmlFc) {
  const accountField = htmlFc.fullcontHTML.querySelector('#accountreconciliation_form_account_id')
  const account = JSON.parse(accountField.getAttribute('selected') || '[]')[0]
  const editing = htmlFc.fullcontHTML.classList.contains('mode-edit')
  if (!editing && !htmlFc.fullcontHTML.classList.contains('mode-add')) return

  cancelLoad(htmlFc)
  const request = htmlFc.pendingRequest
  const recordId = editing ? htmlFc.fullcontHTML.getAttribute('data-dbid') : ''
  if (!editing) {
    multitable.start({ act: 'clean', entityMT: htmlFc.entityMT })
    multitable.start({ act: 'cleanFromValues', entityMT: htmlFc.entityMT })
  }
  if (!account) return
  htmlFc.loadingTransactions = true
  setSelectionLoading(htmlFc, true)

  try {
    const result = await dbRequest.start({
      inf: {
        entity: 'accountreconciliation',
        account_id: String(account),
        reconciliation_id: recordId,
      }
    }, 'server/php/sql/getTransationPending.php')
    if (request !== htmlFc.pendingRequest || !htmlFc.fullcontHTML.classList.contains('fullcont-show')) return
    if (result.status !== 'ok' || result.restriction?.val !== 'ok') {
      throw new Error(result.extrainfo?.message || 'Pending transactions could not be loaded.')
    }

    multitable.start({ act: 'loadResultToForm', entityMT: htmlFc.entityMT, resultMT: result.multiTables })
    multitable.start({ act: 'generator_insert', entityMT: htmlFc.entityMT })
    rememberSelection(htmlFc)
    if (htmlFc.entityMT[0].data.length === 0) dialog.message('This account has no pending transactions.')
  } catch (error) {
    if (request === htmlFc.pendingRequest) dialog.message(error.message || 'Pending transactions could not be loaded.')
  } finally {
    if (request === htmlFc.pendingRequest) {
      htmlFc.loadingTransactions = false
      setSelectionLoading(htmlFc, false)
    }
  }
}

// La seleccion tambien se valida en PHP; no se guarda una conciliacion vacia.
export function verifyMultitable(detail, htmlFc) {
  if (htmlFc.loadingTransactions) {
    dialog.message('Wait until the transactions finish loading.')
    return false
  }
  fullcontForm.getValues(htmlFc)
  if (!htmlFc.entityMT[0].data.some((row) => row.selected === 'true')) {
    dialog.message('Select at least one transaction. Delete the reconciliation if all its lines are incorrect.')
    return false
  }
  return true
}
